/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/ScrollManager',['pixi'], function (PIXI) {
	var ScrollManager = function () {
	};

	ScrollManager.initialize = function () {
		ScrollManager.callbacks = [];
		ScrollManager.scrollEnabled = true;
		var event = (/Firefox/i.test(navigator.userAgent)) ? 'DOMMouseScroll' : 'mousewheel';
		if (document['attachEvent']) {
			document['attachEvent']('on' + event, this.handleMouseWheel.bind(this), {passive: false, capture: true});
		} else if (document.addEventListener) {
			document.addEventListener(event, this.handleMouseWheel.bind(this), {passive: false, capture: true});
		}
	};

	ScrollManager.add = function (element, callback, context) {
		ScrollManager.callbacks.push({element: element, callback: callback, context: context});
	};

	ScrollManager.remove = function (element) {
		var elementIndex;
		ScrollManager.callbacks.forEach(function (cb, i) {
			if (cb.element === element) {
				elementIndex = i;
			}
		});
		if (elementIndex != null) {
			ScrollManager.callbacks.splice(elementIndex, 1);
		}
	};

	ScrollManager.disableScroll = function () {
		ScrollManager.scrollEnabled = false;
	};

	ScrollManager.enableScroll = function () {
		ScrollManager.scrollEnabled = true;
	};

	ScrollManager.handleMouseWheel = function (e) {
		if (!ScrollManager.scrollEnabled) return;
		if (!e) {
			e = window.event;
		}
		e.preventDefault();
		e.returnValue = false;
		var callback = ScrollManager.callbacks[ScrollManager.callbacks.length - 1];
		if (callback) {
			callback.callback.call(callback.context, e);
		}
	};

	return ScrollManager;
});

